import http from "@/tools/http";

export default {
  getAll(organizationUUID, filter) {
    return http.get(`/organizations/${organizationUUID}/interactions`, { params: filter });
  },
  getInteractionCategories(organizationUUID, interactionUUID) {
    return http.get(`/organizations/${organizationUUID}/interactions/${interactionUUID}/categories`);
  },
  updateInteractionCategory(organizationUUID, category) {
    return http.patch(
      `/organizations/${organizationUUID}/interactions/${category.interaction_uuid}/categories`,
      category
    );
  },
  deleteInteractionCategory(organizationUUID, interactionUUID, categoryUUID) {
    return http.delete(`/organizations/${organizationUUID}/interactions/${interactionUUID}/categories/${categoryUUID}`);
  },
  getInteractionMetadatas({ organizationUUID, interactionUUID }) {
    return http.get(`/organizations/${organizationUUID}/interactions/${interactionUUID}/metadata`);
  },
  updateInteractionMetadatas({ organizationUUID, interactionUUID, metadataUUID, data }) {
    return http.patch(
      `/organizations/${organizationUUID}/interactions/${interactionUUID}/metadata/${metadataUUID}`,
      data
    );
  },
  delete(organizationUUID, interactionUUID) {
    return http.delete(`/organizations/${organizationUUID}/interactions/${interactionUUID}`);
  }
};
